/**
 * Sprinklr Live Chat SDK configuration. The App ID selects the Sprinklr app, and so the pool
 * of live agents an escalation reaches. See .claude/context/live-agent.md "App-ID resolution".
 */

import { getHostname } from '../../shared/utils/window-utils';

export const SPRINKLR_APP_IDS = {
  dev: '697cc150c7bd9954ea5e9b24_app_100874948',
  prod: '6a231183637cc8595092eda5_app_100900283',
};

/**
 * Server-set switch that forces the dev app, read from `__EXPERIENCE_PROPS__.expConfiguration`.
 * It only forces dev, never prod. See .claude/context/live-agent.md "App-ID resolution".
 */
export const SPRINKLR_USE_DEV_APP_CONFIG_KEY = 'magic-apron-use-sprinklr-dev-app';

// Exact match with a dev-app fallback (deliberate direction) — see
// .claude/context/live-agent.md ("App-ID resolution").
const PROD_HOSTNAME = 'www.homedepot.com';

const LOCAL_HOSTNAMES = ['localhost', 'localhost.homedepot.com', '127.0.0.1'];

const isLocalDev = LOCAL_HOSTNAMES.includes(getHostname());

/**
 * `true` makes localhost use the real Sprinklr SDK; set it to `false` for the mock (MOCK_MODE).
 * The `SPRINKLR_REAL` env switch on the next line is commented out, so it has no effect.
 */
// const FORCE_REAL_SPRINKLR = typeof process !== 'undefined' && process.env?.SPRINKLR_REAL === 'true';
const FORCE_REAL_SPRINKLR = true;

// Values in expConfiguration are raw — unlike useConfigService, nothing has
// coerced 'true' to a boolean.
const isDevAppForced = () => {
  if (typeof window === 'undefined') return false;
  const value = window.__EXPERIENCE_PROPS__?.expConfiguration?.[SPRINKLR_USE_DEV_APP_CONFIG_KEY];
  return value === true || String(value).trim().toLowerCase() === 'true';
};

export const SPRINKLR_CONFIG = {
  CDN_HOST: 'https://live-chat-static.sprinklr.com',
  ENVIRONMENT: 'prod2',
  LOCALE: 'en',
  MOCK_MODE: isLocalDev && !FORCE_REAL_SPRINKLR,

  get APP_ID() {
    return (getHostname() === PROD_HOSTNAME && !isDevAppForced())
      ? SPRINKLR_APP_IDS.prod
      : SPRINKLR_APP_IDS.dev;
  },
};
